export default "__VITE_ASSET__CpI0NQjH__"